import { render, staticRenderFns } from "./UploadBanner.vue?vue&type=template&id=4dfcc0b0&"
import script from "./UploadBanner.vue?vue&type=script&lang=js&"
export * from "./UploadBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports